<!-- https://github.com/sveltejs/svelte-virtual-list -->

<script>
	import VirtualList from './VirtualList.svelte';
	import items from './data.js';
	import ListItem from './ListItem.svelte';

	let searchTerm = "";
	
	$: filteredList = searchTerm ? items.filter(item => {
		const query = searchTerm.toLowerCase()
		return item.nama.toLowerCase().includes(query) || item.npm.toLowerCase().includes(query) || item.prodi.toLowerCase().includes(query) || item.fakultas.toLowerCase().includes(query)
	}) : [];
	
  let start;
  let end;
	
</script>

<div style="margin: 2% 2% 2% 2%;">
<h1>Rawon -- UI NPM Finder</h1>
<p>Tiada hari berlalu tanpa merindukan Rawon Perpustakaan UI. Situs ini terinspirasi dari <a href="https://geprek.mkamadeus.dev">Geprek ITB NIM Finder</a>.<br/><br/>Data mahasiswa yang tercatat disini berasal dari <a href="https://www.instagram.com/p/C06ALD7RrT3/?utm_source=ig_web_copy_link">Data Publik Pemilih Sementara Pemira IKM UI tahun 2023</a> (diolah <a href="https://github.com/Javunate">Diaz Ramadhan</a>) dan peserta lulus SIMAK UI 2024 (oprekan <a href="https://github.com/Slickerius">Slickerius</a>); hampir semua mahasiswa yang status akademisnya aktif akan tercatat disini.</p>
<p>Situs ini dibikin supaya proses nyari nama dan NPM bagi mahasiswa UI lebih gampang. Tenang aja, situs ini enggak mengumbar data pribadi dari mahasiswa UI :D, niscaya situs ini memudahkan pengerjaan tugas dimana orang lain <strong>matil</strong>.</p>

Masukkan nama/npm/prodi/fakultas: <input bind:value={searchTerm} />
</div>

<div class='container'>
	<VirtualList items={filteredList} bind:start bind:end let:item>
		<ListItem {...item}/>
	</VirtualList>
	<p>menampilkan profil {start}-{end}</p>
</div>

<style>
	.container {
		border-top: 1px solid #333;
		border-bottom: 1px solid #333;
		min-height: 200px;
		height: calc(100vh - 15em);
	}
</style>
